<script>
import { setLocation } from 'www/utils'
import ClinicDoctorsFilter from './ClinicDoctorsFilter.vue'

export default {
  name: 'ClinicDoctorsFilterMain',
  extends: ClinicDoctorsFilter,
  methods: {
    handleFilterChange() {
      const url = this.generateUrl()

      if (url.includes('#')) {
        setLocation(`${this.lpuDoctorsUrl}${url}`)
      }
    },
  },
}
</script>
